import React, { useEffect, useState, lazy, Suspense } from "react";
import Navbar from "../components/Navbar";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Box, IconButton, Paper, CircularProgress } from "@mui/material";
import { ZoomOutMap, Menu as MenuIcon } from "@mui/icons-material";
import ZoomInMapIcon from "@mui/icons-material/ZoomInMap";
import createInstance from "../api";
import { useDispatch, useSelector } from "react-redux";

// Each page loads ONLY when user navigates to it
// Login page no longer waits for all these to download
const DeviceInfo     = lazy(() => import("./DeviceInfo"));
const LiveData       = lazy(() => import("./LiveData"));
const Analytics      = lazy(() => import("./Analytics"));
const Profile        = lazy(() => import("./Profile"));
const Reports        = lazy(() => import("./Reports"));
const Bill           = lazy(() => import("./Bill"));
const VerifyPayments = lazy(() => import("./VerifyPayments"));
const RefundPolicy   = lazy(() => import("./RefundPolicy"));
const PrivacyPolicy  = lazy(() => import("./PrivacyPolicy"));

// Shown while a page chunk is downloading
const PageLoader = () => (
  <div className="flex justify-center items-center h-screen">
    <CircularProgress sx={{ color: "#F97316" }} />
  </div>
);

const Dashboard = () => {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const api = createInstance();
  const clientData = useSelector((state) => state.clientData);
  const dispatch = useDispatch();

  const getData = async () => {
    try {
      const res = await api.post("/paymentinfo", {
        custid: clientData.OrganizationID,
      });
      dispatch({ type: "SET_INVOICE", payload: res.data });
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (ev) => {
      ev.preventDefault();
      return (ev.returnValue = "Are you sure you want to close?");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    getData();
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const [isFullscreen, setIsFullscreen] = useState(false);

  const handelScreen = () => {
    try {
      if (document.fullscreenElement == null) {
        document.documentElement.requestFullscreen();
        setIsFullscreen(true);
      } else if (document.exitFullscreen) {
        document.exitFullscreen();
        setIsFullscreen(false);
      }
    } catch (error) {
      alert(error);
    }
  };

  return (
    <div className="font-sans">
      <BrowserRouter>
        <Box sx={{ display: "flex" }}>
          <Navbar
            mobileOpen={mobileOpen}
            handleDrawerToggle={handleDrawerToggle}
          />
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              width: { sm: `calc(100% - 285px)` },
              backgroundColor: "#EDEDED",
              padding: 0,
              position: "relative",
              overflow: "hidden",
            }}
            className="min-h-screen flex flex-col"
          >
            <Box
              className="absolute top-2 right-5 z-50"
              style={{ cursor: "pointer" }}
              sx={{ display: { xs: "none", md: "block", lg: "block" } }}
              onClick={handelScreen}
            >
              {isFullscreen ? <ZoomInMapIcon /> : <ZoomOutMap />}
            </Box>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{
                mr: 2,
                display: { sm: "none" },
                color: "#818181",
                position: "absolute",
                left: "10px",
              }}
            >
              <MenuIcon />
            </IconButton>

            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/"
                  element={<DeviceInfo />}
                />
                <Route path="/device/:gateWayId"
                  element={<LiveData />}
                />
                <Route path="/analytics"
                  element={<Analytics />}
                />
                <Route path="/profile"
                  element={<Profile />}
                />
                <Route path="/reports"
                  element={<Reports />}
                />
                <Route path="/bill"
                  element={<Bill />}
                />
                <Route path="/refund-policy"
                  element={<RefundPolicy />}
                />
                <Route path="/privacy-policy"
                  element={<PrivacyPolicy />}
                />
                <Route path="/payment/:transId"
                  element={<VerifyPayments />}
                />
              </Routes>
            </Suspense>

            <Paper className="flex justify-center items-center p-2 mt-auto w-[100%] left-0 flex-col bg-white shadow-lg text-sm rounded-lg">
              <span className="text-[#545454] font-medium">
                Zodhya {new Date().getFullYear()}
              </span>
              <div className="flex gap-2">
                <Link
                  to="/refund-policy"
                  className="underline text-blue-600 cursor-pointer"
                >
                  Refund policy
                </Link>
                <Link
                  to="/privacy-policy"
                  className="underline text-blue-600 cursor-pointer"
                >
                  Privacy policy
                </Link>
                <a
                  href="https://www.zodhyatech.com/contact.html"
                  target="_blank"
                  rel="noreferrer"
                  className="underline text-blue-600 cursor-pointer"
                >
                  Contact us
                </a>
              </div>
            </Paper>
          </Box>
        </Box>
      </BrowserRouter>
    </div>
  );
};

export default Dashboard;